var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ClientService from '../../api/ClientService';
import { Loading } from 'element-ui';
import _ from 'lodash';
import ClientGoodsList from './ClientGoodsList.vue';
import SupplierGoodsList from './SupplierGoodsList.vue';
import { EBindGoodWarnType } from '../../enum/EBindGoodWarnType';
var BindGoods = (function (_super) {
    __extends(BindGoods, _super);
    function BindGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clientIds = null;
        _this.business_id = null;
        _this.supplier_to_business_id = null;
        _this.supplierToBusinessIds = null;
        _this.categoryList = [];
        _this.total = 0;
        _this.good_code = null;
        _this.listData = [];
        _this.currentCount = 0;
        _this.searchParams = {};
        _this.isInitPage = true;
        return _this;
    }
    BindGoods.prototype.created = function () {
        this.service = ClientService.getInstance();
    };
    BindGoods.prototype.getClientGoods = function (params) {
        var _this = this;
        this.isInitPage = false;
        this.searchParams = params;
        this.clientIds = params.business_id + '';
        this.business_id = params.business_id;
        this.supplier_to_business_id = params.supplier_to_business_id;
        this.supplierToBusinessIds = params.supplier_to_business_id + '';
        var loadingInstance = Loading.service({ fullscreen: true });
        var promise = this.service.getClientGoods(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.listData = params.page > 1 ? _this.listData.concat(data) : data;
            _this.currentCount = data.length;
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
        return promise;
    };
    BindGoods.prototype.setSelectedRows = function (rows) {
        this.selectRows = rows;
    };
    BindGoods.prototype.bindGood = function (good) {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择要绑定的客户货品！');
            return;
        }
        this.$confirm('确定要绑定选中的货品？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                _this.bindAction(good);
            }
        }).catch(function () {
        });
    };
    BindGoods.prototype.bindAction = function (good, doType) {
        var _this = this;
        if (doType === void 0) { doType = EBindGoodWarnType.正常; }
        var params = {
            supplier_to_business_ids: String(this.$refs.clientGood.formData.supplier_to_business_ids),
            business_goods_id: _.map(this.selectRows, function (item) { return item.goods_id; }).join(','),
            supplier_goods_id: good.goods_id,
            do: doType,
            goods_format_id: good.goods_format_id,
            bind_data: this.selectRows,
        };
        this.service.bindGoods(params).then(function (res) {
            var result = res.data;
            if (result.warn === EBindGoodWarnType.正常) {
                _this.$message.success(result.msg);
                _this.isInitPage = true;
            }
            else if (result.warn === EBindGoodWarnType.确认执行) {
                _this.$confirm(result.msg, '提示', {
                    customClass: 'confirm'
                }).then(function (res) {
                    _this.bindAction(good, EBindGoodWarnType.确认执行);
                }, function () { });
            }
            if (_this.good_code) {
                window._czc.push(["_trackEvent", '供货货品', '绑定货品']);
            }
            else {
                window._czc.push(["_trackEvent", '合作客户列表', '绑定货品']);
            }
        }, function (err) {
            _this.$message.error({ message: err.msg || err.message });
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    BindGoods = __decorate([
        Component({
            components: {
                'client-good': ClientGoodsList,
                'supplier-good': SupplierGoodsList
            }
        })
    ], BindGoods);
    return BindGoods;
}(Vue));
export default BindGoods;
